export default {
  'DownloadReport.title': 'Загрузить отчет',
}
